const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneUs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.788848,9.5762091L8.5092936,11.142754C6.1204472,9.96134,4.1635695,8.0304842,2.9457252,5.6624541L4.6684022,3.3308554L3.5182159,0L0,0C0,3.742007,1.457249,7.2550201,4.1011143,9.8988867C6.7449808,12.542752,10.257991,14,14,14L14,10.549444L10.788848,9.5762091Z",
    fill: "#000000",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneUs);
export default __webpack_public_path__ + "static/media/phone-us.812c202b51ff9961e33fe16c7a1ad5bd.svg";
export { ForwardRef as ReactComponent };